/* src/app/monitor/monitor.component.scss */
.mat-cell {
  text-align: left;
}
.mat-row {
  border-color: #605959;
}
a:hover {
  cursor: pointer;
}
/*# sourceMappingURL=monitor.component.css.map */
